import 'popper.js';
import 'bootstrap';
import 'bootstrap-datepicker';
import ScrollReveal from 'scrollreveal';
// import 'flexslider';
// require("font-awesome-sass-loader");
window.jQuery = $;
window.$ = $;

$(function () {
    $('[data-toggle="tooltip"]').tooltip({
        html: true,
        trigger: window.matchMedia("(min-width: 768px)").matches ? 'hover focus' : 'click'
    });
    $('body').on('click', '.tooltip', function () {
        console.log('test');
        $('[data-toggle="tooltip"]').tooltip('hide');
    })

    // show duplicate videos in bundle
    $('#bundleWarningModal').on('show.bs.modal', function (event) {
        var modal = $(this);
        var button = $(event.relatedTarget);
        var container = button.parents('.card-video');
        var acceptButton = modal.find('.btn-warnig-accept');
        var videosList = container.find('.warning-modal-body').clone();
        modal.find('.modal-body').html(videosList);
        $.each(container.data(), function (i, e) {
//            console.log('name=' + deCase(i) + ' value=' + e);
            acceptButton.attr('data-' + deCase(i), e);
        });
    });
    // add to cart
    $('.featured-videos, .video-product, .bundle-videos, #bundleWarningModal').on('click', '.addToCart', function () {
        $('#bundleWarningModal').modal('hide');
        var obj = $(this);
        var url = $(this).data('url');
        var idVideo = $(this).data('videoId');
        var idUser = $(this).data('userId');
        var action = $(this).data('action');
        var ignoreDuplicates = $(this).data('respectWarnings');
        $.ajax({
            method: "POST",
            url: url,
            data: {
                idVideo: idVideo,
                idUser: idUser,
                action: action,
                ignoreDuplicates: ignoreDuplicates,
            },
            dataType: "json"
        })
                .done(function (json) {
                    var msg = '';
                    $('#addVideoToCart .modal-title').text('Add Video To Cart');
                    if (json.id && json.requested_id) {
                        msg = json.action == 'videoAdd' ? 'Your Video succesfully added to cart' : 'Your Bundle succesfully added to cart';
                        $('#addVideoToCart .modal-content').addClass('text-light bg-success');
                        obj.removeClass('addToCart');
                        obj.addClass('disabled');
                    } else {
                        msg = json.error;
                        $('#addVideoToCart .modal-content').addClass('text-light bg-danger');
                    }
                    $('#addVideoToCart .modal-body').text(msg);
                    $('#addVideoToCart').modal('show');
                });
        return false;
    });
    // add to free video to user videos
    $('.featured-videos .card-video, .video-product').on('click', '.addToUserVideos', function () {
        $('#bundleWarningModal').modal('hide');
        var obj = $(this);
        var url = $(this).attr('href');
        var idVideo = $(this).data('videoId');
        var idUser = $(this).data('userId');
        var action = $(this).data('action');
        var ignoreDuplicates = $(this).data('respectWarnings');
        $.ajax({
            method: "POST",
            url: url,
            data: {
                idVideo: idVideo,
                idUser: idUser,
                action: action,
                ignoreDuplicates: ignoreDuplicates
            },
            dataType: "json"
        })
                .done(function (json) {
                    var msg = '';
                    $('#addVideoToCart .modal-title').text('Add Video To Your Videos');
                    if (json.error == 0) {
                        msg = 'Your Video succesfully added to your video list';
                        $('#addVideoToCart .modal-content').addClass('text-light bg-success');
                        obj.removeClass('addToUserVideos');
                        obj.addClass('disabled');
                    } else {
                        msg = json.errorMsg;
                        $('#addVideoToCart .modal-content').addClass('text-light bg-danger');
                    }
                    $('#addVideoToCart .modal-body').text(msg);
                    $('#addVideoToCart').modal('show');
                });
        return false;
    });
    $('#confirmationModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget); // Button that triggered the
//        var recipient = button.data('whatever') // Extract info from data-* attributes
        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        console.log(button);
        var modal = $(this);
        modal.find('.modal-title').text(button.data('title'));
        modal.find('.modal-body').text(button.data('message'));
        modal.find('.accept-button').text(button.data('confirm')).attr('href', button.data('deleteUrl'));
//        console.log(modal.find('.modal-title'));
    });
    var itemLast = false;
    var itemFirst = true;
    var maxPanel = 0;
//    console.log('itemsCount: ', $('#quizCarousel').data('itemsCount'));
    $('#quizCarousel').on('slide.bs.carousel', function (to) {
        if (maxPanel < to.to) {
            $('.carousel-control-next').hide();
        } else {
            $('.carousel-control-next').show();
        }
        if (!itemLast) {
            $('.carousel-control-prev').show();
        }
        if (itemFirst) {
            $('.carousel-control-prev').hide();
        } // else {
//            $('.carousel-control-prev').show();
//        }
        itemFirst = (to.to == 0);
        itemLast = (to.to == $('#quizCarousel').data('itemsCount'));
        maxPanel = to.to > maxPanel ? to.to : maxPanel;
//        console.log('on_slide->itemLast: ', itemLast);
//        console.log('on_slide->itemFirst: ', itemFirst);
//        console.log('on_slide->maxPanel: ', maxPanel);
//        console.log('to: ', to.to);
        if (itemFirst) {
            $('.carousel-control-prev').hide();
        } else {
            $('.carousel-control-prev').show();
        }
    });
    $('#quizCarousel').on('slid.bs.carousel', function (to) {
        if (itemLast) {
//            alert($('#quizCarousel').data('quizUrl'));
            $('.carousel-control-prev').hide();
            $.get(
                    $('#quizCarousel').data('quizUrl'),
                    function (data) {
//                        console.log(data);
                    }
            );
        }
    });

    $('#evaluationsCarousel').on('slid.bs.carousel', function (e) {
        var container = e.from; //.relatedTarget;
        var item = $('#evaluationsCarousel .active');
        var url = $(this).data('url');
//        console.log('active:', item.hasClass("last"));
        if (item.hasClass("last")) {
            console.log($('#evaluationsCarousel form').serialize());
            $.ajax({
                mathod: "post",
                url: url,
                data: $('#evaluationsCarousel form').serializeArray()
            }
            );
        }
//        console.log(container);
        $('#evaluationsCarousel .carousel-control-next').hide();
    });
    $('#evaluationsCarousel .quiz-checkbox').change(function () {
        console.log('quiz-checkbox.hcange->itemLast: ', itemLast);
        $('.carousel-control-next').show();
        $('.carousel-control-prev').show();
    });

    $('#quizCarousel .quiz-checkbox').change(function () {
//        console.log('quiz-checkbox.hcange->itemLast: ', itemLast);
        var panel = $(this).parents('.quiz-panel');
        panel.find('.list-group-item').removeClass('checked-good checked-bad');
//        console.log($(this).is(':checked') && $(this).data('good'));
        if ($(this).is(':checked') && $(this).data('good')) {
            $(this).parents('.list-group-item').addClass('checked-good');
            panel.find('.answer-rate')
                    .addClass('checked-good')
                    .text('Good answer, go ahead (click next)')
                    .show();
            if (!itemLast) {
                $('.carousel-control-next').show();
            }
        } else {
            $(this).parents('.list-group-item').addClass('checked-bad');
            panel.find('.answer-rate')
                    .addClass('checked-bad')
                    .text('Wrong, try again')
                    .show();
            $('.carousel-control-next').hide();
        }
    });
    $('.js-datepicker').datepicker({
        format: 'yyyy-mm-dd',
        autoclose: true
    });
    $("input[type=file]").change(function () {
//        console.log('file changed');
        var fieldVal = $(this).val();
        // Change the node's value by removing the fake path (Chrome)
        fieldVal = fieldVal.replace("C:\\fakepath\\", "");
        if (fieldVal != undefined || fieldVal != "") {
            $(this).prev(".custom-file-label").text(fieldVal);
        }
//        console.log('file changed: ', fieldVal);

    });
    $('.annual-box').on('click', '.addAnnualToCart', function () {
        var obj = $(this);
        var url = $(this).attr('href');
        $.ajax({
            method: "POST",
            url: url,
            dataType: "json"
        })
                .done(function (json) {
                    if (json.date) {
                        var message = 'Annual was added to cart. You must click cart and pay for full access';
                        $('#addVideoToCart .modal-content').addClass('text-light bg-success');
                        obj.find('i').addClass('text-muted').unwrap();
                        obj.removeClass('addAnnualToCart');
                        obj.addClass('disabled');
                    } else {
                        var message = 'Something went wrong, try again...';
                        $('#addVideoToCart .modal-content').addClass('text-light bg-danger');
                    }
                    $('#addVideoToCart .modal-title').text('Add Annual subscription to cart');
                    $('#addVideoToCart .modal-body').text(message);
                    $('#addVideoToCart').modal('show');
                });
        return false;
    })

    function deCase(s) {
        return s.replace(/[A-Z]/g, function (a) {
            return '-' + a.toLowerCase();
        });
    }

    var len = $('script').filter(function () {
        return ($(this).attr('src') == 'https://www.google.com/recaptcha/api.js?render=6LfbSqIUAAAAAFus0r0gdQ9J-vLk46PRMTe3NAeH');
    }).length;

    if (len) {
        grecaptcha.ready(function () {
            var link = $('#recaptchaResponse').data('link');
            grecaptcha.execute('6LfbSqIUAAAAAFus0r0gdQ9J-vLk46PRMTe3NAeH', {action: 'homepage'}).then(function (token) {
                var recaptchaResponse = document.getElementById('recaptchaResponse');
                recaptchaResponse.value = token;
                $.post(link, {token: token})
                        .done(function (data) {
                            if (data.score > .5) {
                                $('#registerSubmit').prop('type', 'submit').removeAttr("disabled");
                            }
                        });
            });
        });
    }

    var footerInOutVisible = false;
    var footerCanLoad = true;
    var videoPage = 0;
    var canUse = $('#getMoreVideos').data('scrollreveal');

    console.log('canUse: ', canUse);
    if (canUse) {
        $(window).on('resize scroll', function () {

            var el = $('#getMoreVideos');
            var elementTop = el.offset().top;
            var elementBottom = elementTop + el.outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            if (elementBottom > viewportTop && elementTop < viewportBottom) {
                console.log('in');
                footerInOutVisible = true;
                if (footerInOutVisible && footerCanLoad) {
                    console.log('loading');
                    var gethtml = null;
                    ++videoPage;
                    $('#videosSpinner').show();
                    $.ajax({
//                    url: el.data('url') + '?limit=6&page=' + videoPage,
                        url: el.data('url'),
                        data: {limit: 9, page: videoPage},
                        dataType: 'html'
                    })
                            .done(function (gethtml) {
                                $('#featuredVideos').append(gethtml);
                                $('#videosSpinner').hide();
                            });
                }

                footerCanLoad = false;
            } else {
                console.log('out');
                footerInOutVisible = false;
                footerCanLoad = true;
            }

            if (footerInOutVisible && footerCanLoad) {
                console.log('loading');
            }
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 6
// module chunks = 0